import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import * as debug from 'debug';

@Pipe({
  name: 'filterUserNames',
})
export class FilterUserNamesPipe implements PipeTransform {
  log = debug('app:FilterUserNamesPipe');
  transform(
    value: object,
    searchTerm,
    keys = ['username', 'firstName', 'lastName'],
    ...args
  ) {
    const search = String(searchTerm || ''),
      splits = search.split(' ').map(d => d.trim().toLowerCase());
    if (!search) {
      return value;
    }
    return _.filter(value, user => {
      const values = _.map(keys, k => {
        return String(_.get(user, k) || '').toLowerCase();
      });

      let hasBad = _.find(
        splits.map(split => {
          return !_.find(values, v => {
            return v.match(split);
          });
        })
      );
      // console.log('running from direct messages filter 30');
      return !hasBad;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filter-user-names/filter-user-names.ts